// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"03c13897","224":"a592d6ae","330":"1398a543","611":"7658471f"}[chunkId] + ".css";
};